const initialState = () => ({
  activeFields: [],
  defaults: [],
  pendingTemplateFieldOptions: {},
  portfolio: null,
  templates: null,
});

const state = initialState();

export default state;
